module.exports = __webpack_public_path__ + "static/media/A_Sky_Full_Of_Stars.552e1876.mp3";